import './App.css';
import { Routes, Route } from "react-router-dom";

import ColorSlider from './components/ColorSlider';
import FigsByCategory from './components/FigsByCategory';
import Footer from './components/Footer';
import Header from './components/Header';
import HeroImage from './components/HeroImage';
import Offers from './components/Offers';
import PicksForYouSlider from './components/PicksForYouSlider';
import ProductDetails from "./components/ProductDetails";
import WearWithIt from "./components/WearWithIt";
import Categories from "./components/Categories";
import About from "./components/About";
import BranchMap from "./components/BranchMap";
import BedLinen from "./pages/hospitality/BedLinen";
import BathLinen from "./pages/hospitality/BathLinen";
import AboutLinen from "./pages/hospitality/AboutLinen";

function App() {
  return (
    <div className="App">

      {/* Header remains common */}
      <Header />

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <HeroImage />
              <ColorSlider />
              <FigsByCategory />
              <Offers />
              <PicksForYouSlider />
                <BranchMap
                mapImage="/world_map.jpeg" // replace with your image
              />
            </>
          }
        />

        {/* PRODUCT DETAILS PAGE */}
        <Route path="/product/:slug" element={ <>
          <ProductDetails />
          </>} />

          {/* Collection Page */}
          <Route path="/collection/:slug" element={ <>
          <ProductDetails />
          <WearWithIt />
          </>} />

          <Route path="/categories/:slug" element={<Categories />} />

          <Route path="/about/" element={<About/>} />

              <Route path="/hospitality/bed-linen" element={<BedLinen />} />
          <Route path="/hospitality/bath-linen" element={<BathLinen />} />
          <Route path="/hospitality/about-linen" element={<AboutLinen />} />
          

      </Routes>

      {/* Footer remains common */}
      <Footer />

    </div>
  );
}

export default App;
